export const APP_SCROLLABLE_WRAPPER_ID = 'app-scrollable-wrapper'
export const mainWrapperContainerName = 'main-content'
